const offersCategory = (title, depth) =>
  depth === 1 &&
  title &&
  (title.indexOf('Offers') >= 0 || title.indexOf('Black Friday') >= 0);

export default offersCategory;
